import { TileColumn } from './tile-column';

export class TileDay extends TileColumn {
    constructor(
        public name?: string,
        public displayName?: string,
        public tiles?: Array<StorytellingRecord>,
        public day?: number,
        public month?: any,
        public year?: any
    ) {
        super(name, displayName, tiles);
    }
}
